module.exports = __webpack_public_path__ + "img/gabarito-1.7d45cc98.png";